import axios from 'axios';

export const API_BASE = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercept requests to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },
  logout: () => {
    localStorage.removeItem('token');
  },
  verify: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  }
};

export const blogService = {
  getAll: async () => {
    const response = await api.get('/blogs');
    return response.data;
  },
  getBySlug: async (slug) => {
    const response = await api.get(`/blogs/slug/${slug}`);
    return response.data;
  },
  create: async (blogData) => {
    const response = await api.post('/blogs', blogData);
    return response.data;
  },
  update: async (id, blogData) => {
    const response = await api.put(`/blogs/${id}`, blogData);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  }
};

export default api;
